
export const SP_ORDER_ATTACHMENT_CREATE = "SP_ORDER_ATTACHMENT_CREATE";
export const SP_ORDER_ATTACHMENT_CREATE_SUCCESS = "SP_ORDER_ATTACHMENT_CREATE_SUCCESS";
export const SP_ORDER_ATTACHMENT_CREATE_ERROR = "SP_ORDER_ATTACHMENT_CREATE_ERROR";
export const SP_ORDER_ATTACHMENT_DELETE = "SP_ORDER_ATTACHMENT_DELETE";
export const SP_ORDER_ATTACHMENT_DELETE_SUCCESS = "SP_ORDER_ATTACHMENT_DELETE_SUCCESS";
export const SP_ORDER_ATTACHMENT_DELETE_ERROR = "SP_ORDER_ATTACHMENT_DELETE_ERROR";
export const SP_ORDER_ATTACHMENTS_LIST_FILTERED = "SP_ORDER_ATTACHMENTS_LIST_FILTERED";
export const SP_ORDER_ATTACHMENTS_LIST_FILTERED_SUCCESS = "SP_ORDER_ATTACHMENTS_LIST_FILTERED_SUCCESS";
export const SP_ORDER_ATTACHMENTS_LIST_FILTERED_ERROR = "SP_ORDER_ATTACHMENTS_LIST_FILTERED_ERROR";